<div class="orders-table-container bg-primary-blue-50 pt-5 px-5" [ngClass]="hasLoadMore ? 'pb-3' : 'pb-6'">
  <div *ngIf="orders.length === 0" class="text-center">
    <img src="./assets/icons/divisional-icons/clipboard-blue.svg" height="80px" alt="Clipboard Icon" />
    <h2 class="mt-5 mb-0">{{ emptyMessageTitle }}</h2>
    <p class="p3 mt-1 mb-6">{{ emptyMessage }}</p>
  </div>
  <p-table
    *ngIf="orders.length > 0"
    [value]="orders"
    responsiveLayout="stack"
    dataKey="id"
    class="dashboard-active-orders"
  >
    <ng-template pTemplate="header">
      <tr>
        <th data-cy="orders-list-order-shipment-type-header">Category</th>
        <th data-cy="orders-list-order-number-header">Order Number</th>
        <th data-cy="orders-list-order-status-header">Order Status</th>
        <th data-cy="orders-list-order-action-header">Action</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="4" class="py-7" data-cy="orders-list-empty-message-container">
          <div class="table-empty-message-container flex flex-column align-items-center justify-content-center">
            <h4 class="table-empty-message-title m-0" data-cy="orders-list-empty-message-title">
              {{ emptyMessageTitle }}
            </h4>
            <p class="table-empty-message p4" data-cy="orders-list-empty-message-content">{{ emptyMessage }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order let-expanded="expanded">
      <tr class="spacer">
        <td [attr.colspan]="4"></td>
      </tr>
      <tr [ngClass]="{ 'bottom-not-rounded': expanded, 'bottom-rounded': !expanded }" data-cy="orders-list-item">
        <td data-cy="orders-list-item-shipment-type">
          <span class="p-column-title" data-cy="orders-list-order-shipment-type-header">Category</span>
          {{ order.shipmentDescription }}
        </td>
        <td class="order-number" data-cy="orders-list-item-number">
          <a
            *ngIf="!hideOrderLink(order)"
            attr.aria-label="Order: {{ order.id }}"
            [routerLink]="['/orders', order.id]"
            [ngClass]="{ 'font-semibold': (isBelowPrime$ | async) }"
            >{{ order.id }}</a
          >
          <span *ngIf="hideOrderLink(order)" [ngClass]="{ 'font-semibold': (isBelowPrime$ | async) }">{{
            order.id
          }}</span>
          <div *ngIf="order.detailedStatus?.length" style="float: right">
            <button
              type="button"
              pButton
              [pRowToggler]="order"
              class="p-button-text p-button-rounded p-button-plain expansion-button-2"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              [attr.aria-label]="expanded ? 'Collapse' : 'Expand'"
              data-cy="orders-list-expand-button"
              appClickEvent
              eventName="orders_list_{{ expanded ? 'hide' : 'show' }}_detailed_status"
            ></button>
          </div>
        </td>
        <td data-cy="orders-list-item-status">
          <span class="p-column-title" data-cy="orders-list-order-status-header">Order Status</span>
          <div class="flex flex-column">
            <app-order-status-tag *ngIf="!!order.status" [orderStatus]="order.status"> </app-order-status-tag>
            <div *ngIf="order.deliveryDate" class="inline lg:flex lg:flex-column xl:inline">
              <span class="text-black-400 p4 font-normal mr-1">Delivery Date: </span>
              <span>
                <span class="p3 font-semibold">{{ order.deliveryDate | formatDate }}</span>
                <i
                  class="mi-round mi-help-outline ml-2 text-sm vertical-align-middle -mt-1 black-icon cursor-pointer"
                  pTooltip="This is the delivery date for this order."
                  tooltipEvent="focus"
                  [tabindex]="0"
                  [tooltipPosition]="(isBelowPrime$ | async) === true ? 'left' : 'right'"
                ></i>
              </span>
            </div>
            <div *ngIf="order.targetedShipDate && !order.isDelivered" class="inline lg:flex lg:flex-column xl:inline">
              <span class="text-black-400 p4 font-normal mr-1">{{
                order.isShipped ? 'Shipped Date: ' : 'Estimated Ship Date: '
              }}</span>
              <span>
                <span class="p3 font-semibold">{{
                  order.isFutureOrder || !order.targetedShipDate
                    ? 'To Be Determined'
                    : (order.targetedShipDate | formatDate)
                }}</span>
                <i
                  class="mi-round mi-help-outline ml-2 text-sm vertical-align-middle -mt-1 black-icon cursor-pointer"
                  [pTooltip]="
                    order.isShipped
                      ? 'This is the shipping date for this order.'
                      : 'This is the estimated ship date for this order.'
                  "
                  tooltipEvent="focus"
                  [tabindex]="0"
                  [tooltipPosition]="(isBelowPrime$ | async) === true ? 'left' : 'right'"
                ></i>
              </span>
            </div>
          </div>
        </td>
        <td data-cy="orders-list-item-action">
          <span
            *ngIf="order.needsAuthorization || (order.isShipped && order.trackingNumberUrl) || order.statusDescription || order.oneDotStatus === OneDotOrderStatus.PaymentRequired"
            class="p-column-title"
            data-cy="orders-list-order-action-header"
            >Action</span
          >
          <button
            *ngIf="order.needsAuthorization"
            pButton
            type="button"
            label="Review Order"
            class="p-button-outlined"
            [ngClass]="{ 'p-button-sm': (isBelowXl$ | async) === true }"
            (click)="goToAuthorizeOrder(order.id)"
            data-cy="orders-list-item-authorize-button"
            appClickEvent
            eventName="orders_list_begin_authorize_order"
          ></button>
          <button
            *ngIf="order.isShipped && order.trackingNumberUrl"
            pButton
            type="button"
            label="Track Order"
            class="p-button-outlined"
            [ngClass]="{ 'p-button-sm': (isBelowXl$ | async) === true }"
            (click)="goToTrackOrder(order.trackingNumberUrl)"
            data-cy="orders-list-item-tracking-link"
            appClickEvent
            eventName="orders_list_track_order"
          ></button>
          <button
            *ngIf="order.status === OneDotOrderStatus.PaymentRequired"
            pButton
            type="button"
            label="Make Payment"
            class="p-button-outlined"
            [ngClass]="{ 'p-button-sm': (isBelowXl$ | async) === true }"
            (click)="goToPayment(order.id)"
            data-cy="orders-list-item-payment-button"
            appClickEvent
            eventName="orders_list_make_payment"
          ></button>
          <div *ngIf="order.statusDescription">
            <p class="p4 my-0 action-text">
              {{ order.statusDescription }}
            </p>
          </div>
        </td>
        <td class="expansion-button-td">
          <div
            *ngIf="order.detailedStatus && order.detailedStatus.length"
            class="flex flex-column h-full justify-content-center"
          >
            <button
              type="button"
              pButton
              [pRowToggler]="order"
              class="p-button-text p-button-rounded p-button-plain expansion-button-1"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              [attr.aria-label]="expanded ? 'Collapse' : 'Expand'"
              data-cy="orders-list-expand-button"
              appClickEvent
              eventName="orders_list_{{ expanded ? 'hide' : 'show' }}_detailed_status"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template *ngIf="hasLoadMore" pTemplate="summary">
      <div class="flex w-full justify-content-center">
        <app-spinner *ngIf="isLoadingMoreOrders"></app-spinner>
        <div *ngIf="isLoadingMoreOrders !== true">
          <button
            pButton
            type="button"
            label="View More"
            class="p-button-text p-button-sm"
            (click)="loadMoreOrders()"
            data-cy="orders-list-view-more-button"
            appClickEvent
            eventName="orders_list_view_more_orders"
          ></button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-order>
      <tr class="expanded-section" data-cy="orders-list-item-expanded-content">
        <td colspan="5" class="expansion-td">
          <div class="flex flex-column align-items-start lg:flex-row" data-cy="order-status">
            <p class="p3 font-semibold mt-0 mr-0 md:mr-5">Order status:</p>
            <app-order-status-timeline [orderDetailedStatus]="order.detailedStatus"></app-order-status-timeline>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
